import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import ReactPlayer from "react-player";
import { useState, useEffect, useRef, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import LocalMoviesIcon from "@mui/icons-material/LocalMovies";
import { useContext } from "react";
import MainContext from "../../context/mainContext";
// import Draggable from "react-draggable"; // The default
// import Tutorialumlang from "./Tutorialumlang";
// import { Tooltip } from 'react-tooltip'
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import * as React from "react";
import { Button, Paper } from "@mui/material";
import SubtitleOneContentControl from "./SubtitleOneContentControl";
import { rpPlayer, psPlayer } from "./utilsFunction";
import SubtitleOneTranslations from "./Translations/SubtitleOneTranslations";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AccessDenySubtitleTwo from "./AccessDenySubtitleTwo";
import DraggableComponent from "./DraggableComponent";
import BasicSpeedDial from "./SpeedDial/BasicSpeedDial";
import CompareSubsPlaying from "./CompareSubsPlaying/CompareSubsPlaying";
import SelectMovie from "./SelectMovie";
import SelectSubtitles from "./SelectSubtitles";
import SubtitileStyles from "./Styles/SubtitileStyles";
import SynchronizeSubtitles from "./SynchronizeSubtitles";
import AccordianContents from "./AccordianContents/AccordianContents";
import StartBox from "./AccordianContents/StartBox";
import IconButton from "@mui/material/IconButton";
import GTranslateIcon from "@mui/icons-material/GTranslate";
import ShadowingSettings from "./Shadowing/ShadowingSettings";
import ShadowingButton from "./Shadowing/ShadowingButton";
import KeysModal from "./KeysModal/KeysModal";
import ShortCutEnable from "./KeysModal/ShortCutEnable";
import SubtitleSidebar from "./SubtitleSidebar/SubtitleSidebar";

function VideoPlayer(props) {
  const onDrop = useCallback((acceptedFiles) => {
    handleVideoInfo({
      ...videoInfo,
      ...{
        videoFile: URL.createObjectURL(acceptedFiles[0]),
        fileName: acceptedFiles[0]["name"],
        filmName: acceptedFiles[0]["name"].slice(0, 8),
      },
    });
    handleOpenSelectVideoBox();
    removeSubtitlesTracks();
  }, []);
  const { getRootProps, getInputProps, open, isDragActive } = useDropzone({
    noClick: true,
    onDrop,
  });
  const {
    handleOpenSelectVideoBox,
    handleFullScreen,
    checkRpPsPlayer,
    controlVideoPlayer,
    selectVideoBox,
    handleCloseSelectVideoBox,
    selectSubtitlesBox,
    handleCloseSelectSubtitlesBox,
    showSubtitleStyleBox,
    handleShowSubtitleStyleBox,
    handleOpenSelectSubtitlesBox,
    semiAutoShadowing,
    handleSemiAutoShadowing,
    pgRef,
    signInBox,
    moreInfoRef,
    removeSubtitlesTracks,
  } = props;
  const {
    videoInfo,
    userWordsDifficultyLevel,
    subWordLearningStyles,
    cferWordsLevel,
    subWordCEFRStyles,
    subtitleOneWords,
    subtitleTwoContenet,
    userTypes,
    subtitleStylesData,
    subtitleOneContenet,
    handleVideoInfo,
    allSubtitleOne,
    allSubtitleTwo,
    handleSubtitleStylesData,
  } = useContext(MainContext);
  const [controlHover, setControlHover] = useState({
    useHover: false,
    disableHover: false,
    play: false,
  });
  const [mainCompareSubsOpen, setCompareSubsOpen] = useState(false);
  const [repeatOn, setRepeatOn] = useState({
    repeatTime: 0,
    repeat: 0,
    state: false,
  });
  const [oldPlayState, setOldPlayState] = useState({
    pgnumber: 0,
    play: false,
  });
  const [fullscreenState, setFullscreenState] = useState(true);
  const [useShortcuts, setUseShortcuts] = useState({ on: true, enable: true });
  const [showShortcutsAction, setShowShortcutsAction] = useState({
    show: false,
    typeAction: false,
    changeValue: false,
  });
  const [activeSubtitleOneId, setActiveSubtitleOneId] = useState(false);
  const [activeSubtitleTwoId, setActiveSubtitleTwoId] = useState(false);
  const [unlimitedRepeat, setUnlimitedRepeat] = useState(false);
  const [subtitleSideBar, setSubtitleSideBar] = useState({
    active: false,
    size: 25,
  });
  const [moreDictWindow, setMoreDictWindow] = useState(false);
  const [playSyncTwoSub, setPlaySyncTwoSub] = React.useState(true);
  const [subtitleTwoDisable, setSubtitleTwoDisable] = React.useState(false);
  const [searchSubtitlesBoxData, setSearchSubtitlesData] = useState({});
  const [playbackRate, setplaybackRate] = useState(1);
  const [volume, setVolume] = useState(75);
  const [muted, setMuted] = useState(false);
  const [hiddenSub, setHiddenSub] = useState("show");
  const [mouseOnVideo, setMouseOnVideo] = useState(false);
  const [activeShadowing, setActiveShadowing] = useState(false);
  const [subtitlesTimeShift, setSubtitlesTimeShift] = React.useState({
    one: 0,
    two: 0,
  });
  const [allSubShadowing, setAllSubShadowing] = useState({
    subOne: [],
    subTwo: [],
  });
  const [compareSubtitlesBoxData, setCompareSubtitlesData] = useState({
    newData: false,
    subOne: {},
    subTwo: {},
  });
  const ref = useRef();
  const videoRef = useRef();
  const handleDisableHoverPause = (status) => {
    if (!controlHover["useHover"] && status)
      setControlHover({ useHover: false, disableHover: true, play: false });
    else if (!controlHover["useHover"] && !status)
      setControlHover({ useHover: false, disableHover: false, play: true });
  };

  const handleActiveSubtitleOneId = (id) => {
    setActiveSubtitleOneId(id);
  };
  const handleActiveSubtitleTwoId = (id) => {
    setActiveSubtitleTwoId(id);
  };
  const handleSubtitleSideBar = (newData) => {
    setSubtitleSideBar({ ...subtitleSideBar, ...newData });
  };

  const seekToVideo = (time) => {
    videoRef.current.seekTo(time, "seconds");
  };

  const handleUseShortcuts = (newValue) => {
    setUseShortcuts({ ...useShortcuts, ...newValue });
  };
  const disableShortCut = useRef(false);
  const playerRef = useRef({
    volume,
    playbackRate,
    activeSubtitleOneId,
    unlimitedRepeat,
    videoFile: videoInfo.videoFile,
    controlHover,
    subtitlesTimeShift,
    useShortcuts,
    muted,
    subtitleSideBar,
    mouseOnVideo,
  });

  const handlePlaySyncTwoSub = (state) => {
    setPlaySyncTwoSub(state);
  };
  const handleSubtitleTwoDisable = (state) => {
    setSubtitleTwoDisable(state);
  };
  const handleMainCompareSubsOpen = (state) => {
    setCompareSubsOpen(state);
    if (!state) handleOpenSelectSubtitlesBox();
  };
  const handleSearchSubtitlesBoxOpen = (state, dataChange, data) => {
    if (dataChange) setSearchSubtitlesData({ dataChange, ...data });
  };
  const handleCompareSubtitlesData = (data) => {
    let cp = { ...compareSubtitlesBoxData, ...data };
    setCompareSubtitlesData(cp);
  };
  const handlePlayingStatus = (Status, moreInfo) => {
    if (moreInfo == "openDict") {
      setMoreDictWindow(true);
    } else if (moreInfo == "closeDict") {
      setMoreDictWindow(false);
    }
    if (!moreDictWindow) {
      if (controlHover["disableHover"]) return;
      else if (!controlHover["disableHover"] && !Status) {
        setControlHover({ useHover: true, disableHover: false, play: false });
      } else if (!controlHover["disableHover"] && Status) {
        setControlHover({ useHover: false, disableHover: false, play: true });
      }
    }
  };

  const handleFullscreenState = (state) => {
    setFullscreenState(state);
  };

  const handleShowAllSubtitlesInShadowing = () => {
    handlePlayingStatus(false);
    let subOne = allSubtitleOne.filter(
      (sub, idx) =>
        sub["startSeconds"] > semiAutoShadowing["startTime"] &&
        sub["startSeconds"] < semiAutoShadowing["endTime"] + 0.5
    );
    let subTwo = allSubtitleTwo.filter(
      (sub, idx) =>
        sub["startSeconds"] > semiAutoShadowing["startTime"] &&
        sub["startSeconds"] < semiAutoShadowing["endTime"] + 0.5
    );
    setAllSubShadowing({ subOne, subTwo });
  };

  const handleSubtitlesTimeShift = (subNumber, time) => {
    let cp = { ...subtitlesTimeShift };
    if (subNumber == 1) cp["one"] = time;
    else cp["two"] = time;
    setSubtitlesTimeShift(cp);
  };
  const controlTimeShift = (subNumber, time) => {
    const video = document.querySelector("video");
    if (video) {
      let textTracks =
        subNumber == 1 ? video.textTracks[0] : video.textTracks[1];
      if (textTracks) {
        let floatTime = parseFloat(time);
        let cp = { ...playerRef.current.subtitlesTimeShift };
        if (subNumber == 1) cp["one"] = (cp["one"] * 10 + floatTime * 10) / 10;
        else cp["two"] = (cp["two"] * 10 + floatTime * 10) / 10;
        setSubtitlesTimeShift(cp);
        Array.from(textTracks.cues).forEach((cue) => {
          cue.startTime += floatTime;
          cue.endTime += floatTime;
        });
      }
    }
  };

  useEffect(() => {
    let MainVideo = document.getElementById("MainVideo");
    let SubtitleContainer = document.getElementById("SubtitleContainer");
    MainVideo.append(SubtitleContainer);
    playerRef.current = {
      ...playerRef.current,
      ...{ videoFile: videoInfo.videoFile },
    };
  }, [videoInfo]);

  const keydownAction = (event) => {
    if (pgRef.current == 0) {
      if (
        !disableShortCut.current &&
        playerRef.current.videoFile &&
        playerRef.current.useShortcuts.on
      ) {
        let key;
        if (event.shiftKey) key = `shift${event.key.toLowerCase()}`;
        else if (event.altKey) key = `alt${event.key.toLowerCase()}`;
        else key = event.key.toLowerCase();
        let newvalue;
        let copyValue;
        let typeAction = false;
        let changeValue = false;
        switch (key) {
          case "arrowright":
            videoRef.current.seekTo(
              videoRef.current.getCurrentTime() + 10,
              "seconds"
            );
            typeAction = "forward";
            break;
          case "arrowleft":
            videoRef.current.seekTo(
              videoRef.current.getCurrentTime() - 10,
              "seconds"
            );
            typeAction = "rewind";
            break;
          case "l":
            videoRef.current.seekTo(
              videoRef.current.getCurrentTime() + 5,
              "seconds"
            );
            typeAction = "forward";
            changeValue = 5;
            break;
          case "j":
            videoRef.current.seekTo(
              videoRef.current.getCurrentTime() - 5,
              "seconds"
            );
            typeAction = "rewind";
            changeValue = -5;
            break;
          case "arrowup":
            newvalue = playerRef.current.volume + 5;
            if (newvalue < 100) {
              setVolume(newvalue);
              changeValue = newvalue;
            } else {
              setVolume(100);
              changeValue = 100;
            }
            if (playerRef.current.muted) setMuted(false);
            typeAction = "volume";
            break;
          case "arrowdown":
            newvalue = playerRef.current.volume - 5;
            if (newvalue > 1) {
              setVolume(newvalue);
              changeValue = newvalue;
            } else {
              setVolume(0);
              changeValue = 0;
            }
            if (playerRef.current.muted) setMuted(false);
            typeAction = "volume";
            break;
          case "shift-":
            newvalue = (playerRef.current.playbackRate * 10 - 1) / 10;
            if (newvalue > 0.1) {
              setplaybackRate(newvalue);
              changeValue = newvalue;
            } else {
              setplaybackRate(0.1);
              changeValue = 0.1;
            }
            typeAction = "playbackRate";
            break;
          case "shift_":
            newvalue = (playerRef.current.playbackRate * 10 - 1) / 10;
            if (newvalue > 0.1) {
              setplaybackRate(newvalue);
              changeValue = newvalue;
            } else {
              setplaybackRate(0.1);
              changeValue = 0.1;
            }
            typeAction = "playbackRate";
            break;
          case "shift+":
            newvalue = (playerRef.current.playbackRate * 10 + 1) / 10;
            if (newvalue < 10) {
              setplaybackRate(newvalue);
              changeValue = newvalue;
            } else {
              setplaybackRate(10);
              changeValue = 10;
            }
            typeAction = "playbackRate";
            break;
          case "shift*":
            setplaybackRate(1);
            changeValue = 1;
            typeAction = "playbackRate";
            break;
          case "z":
            handleSubtitleSideBar({
              active: !playerRef.current.subtitleSideBar.active,
            });
            break;
          case " ":
            const newState = !videoRef.current.player.isPlaying;
            changeValue = newState;
            setTimeout(() => {
              let cp = { ...playerRef.controlHover };
              cp["play"] = newState;
              setControlHover(cp);
            }, 500);
            typeAction = "playPause";
            break;
          case "k":
            const newState2 = !videoRef.current.player.isPlaying;
            changeValue = newState2;
            let cp = { ...playerRef.controlHover };
            cp["play"] = newState2;
            setControlHover(cp);
            typeAction = "playPause";
            break;
          case "enter":
            const getState = videoRef.current.player.isPlaying;
            changeValue = !moreInfoRef.current.fullScreen;
            moreInfoRef.current.fullScreen
              ? handleFullScreen.exit()
              : handleFullScreen.enter();
            setTimeout(() => {
              let cp = { ...playerRef.controlHover };
              cp["play"] = getState;
              setControlHover(cp);
            }, 50);
            typeAction = "fulScreen";
            break;
          case "a":
            if (playerRef.current.activeSubtitleOneId) {
              if (playerRef.current.activeSubtitleOneId > 1) {
                videoRef.current.seekTo(
                  moreInfoRef.current.allSubtitleOne[
                    playerRef.current.activeSubtitleOneId - 2
                  ]["startSeconds"],
                  "seconds"
                );
                typeAction = "repeatPrev";
              }
            }
            break;
          case "s":
            if (playerRef.current.activeSubtitleOneId) {
              videoRef.current.seekTo(
                moreInfoRef.current.allSubtitleOne[
                  playerRef.current.activeSubtitleOneId - 1
                ]["startSeconds"],
                "seconds"
              );
              typeAction = "repeat";
            }
            break;
          case "d":
            if (playerRef.current.activeSubtitleOneId) {
              if (
                playerRef.current.activeSubtitleOneId <=
                moreInfoRef.current.allSubtitleOne.length
              ) {
                videoRef.current.seekTo(
                  moreInfoRef.current.allSubtitleOne[
                    playerRef.current.activeSubtitleOneId
                  ]["startSeconds"],
                  "seconds"
                );
                typeAction = "repeatNext";
              }
            }
            break;
          case "f":
            if (playerRef.current.activeSubtitleOneId) {
              if (playerRef.current.unlimitedRepeat) setUnlimitedRepeat(false);
              else {
                setUnlimitedRepeat(
                  moreInfoRef.current.allSubtitleOne[
                    playerRef.current.activeSubtitleOneId - 1
                  ]["startSeconds"]
                );
                videoRef.current.seekTo(
                  moreInfoRef.current.allSubtitleOne[
                    playerRef.current.activeSubtitleOneId - 1
                  ]["startSeconds"],
                  "seconds"
                );
              }
              typeAction = "unlimitedRepeat";
            }
            break;
          case "t":
            copyValue = { ...moreInfoRef.current.subtitleStylesData };
            changeValue = !moreInfoRef.current.subtitleStylesData.sub1_hidden;
            copyValue[`sub1_hidden`] =
              !moreInfoRef.current.subtitleStylesData.sub1_hidden;
            handleSubtitleStylesData(copyValue);
            typeAction = "sub1_hidden";
            break;
          case "y":
            copyValue = { ...moreInfoRef.current.subtitleStylesData };
            changeValue = !moreInfoRef.current.subtitleStylesData.sub2_hidden;
            copyValue[`sub2_hidden`] =
              !moreInfoRef.current.subtitleStylesData.sub2_hidden;
            handleSubtitleStylesData(copyValue);
            typeAction = "sub2_hidden";
            break;
          case "q":
            copyValue = { ...moreInfoRef.current.subtitleStylesData };
            typeAction = "sub1_fontSizeIncrease";
            if (moreInfoRef.current.subtitleStylesData.sub1_fontSize >= 60) {
              changeValue = 60;
              break;
            } else {
              changeValue =
                moreInfoRef.current.subtitleStylesData.sub1_fontSize + 5;
              copyValue[`sub1_fontSize`] = changeValue;
            }
            handleSubtitleStylesData(copyValue);
            break;
          case "w":
            copyValue = { ...moreInfoRef.current.subtitleStylesData };
            typeAction = "sub1_fontSizeDecrease";
            if (moreInfoRef.current.subtitleStylesData.sub1_fontSize <= 10) {
              changeValue = 10;
              break;
            } else {
              changeValue =
                moreInfoRef.current.subtitleStylesData.sub1_fontSize - 5;
              copyValue[`sub1_fontSize`] = changeValue;
            }
            handleSubtitleStylesData(copyValue);
            break;
          case "e":
            copyValue = { ...moreInfoRef.current.subtitleStylesData };
            typeAction = "sub2_fontSizeIncrease";
            if (moreInfoRef.current.subtitleStylesData.sub2_fontSize >= 60) {
              changeValue = 60;
              break;
            } else {
              changeValue =
                moreInfoRef.current.subtitleStylesData.sub2_fontSize + 5;
              copyValue[`sub2_fontSize`] = changeValue;
            }
            handleSubtitleStylesData(copyValue);
            break;
          case "r":
            copyValue = { ...moreInfoRef.current.subtitleStylesData };
            typeAction = "sub2_fontSizeDecrease";
            if (moreInfoRef.current.subtitleStylesData.sub2_fontSize <= 10) {
              changeValue = 10;
              break;
            } else {
              changeValue =
                moreInfoRef.current.subtitleStylesData.sub2_fontSize - 5;
              copyValue[`sub2_fontSize`] = changeValue;
            }
            handleSubtitleStylesData(copyValue);
            break;
          case "]":
            if (playerRef.current.activeSubtitleOneId) {
              typeAction = "controlTimeShiftOne";
              changeValue =
                playerRef.current.subtitlesTimeShift.one * 1000 + 100;
              controlTimeShift(1, 0.1);
            }
            break;
          case "[":
            if (playerRef.current.activeSubtitleOneId) {
              typeAction = "controlTimeShiftOne";
              changeValue =
                playerRef.current.subtitlesTimeShift.one * 1000 - 100;
              controlTimeShift(1, -0.1);
            }
            break;
          case "shift}":
            if (playerRef.current.activeSubtitleOneId) {
              typeAction = "controlTimeShiftTwo";
              changeValue =
                playerRef.current.subtitlesTimeShift.two * 1000 + 100;
              controlTimeShift(2, 0.1);
            }
            break;
          case "shift{":
            if (playerRef.current.activeSubtitleOneId) {
              typeAction = "controlTimeShiftTwo";
              changeValue =
                playerRef.current.subtitlesTimeShift.two * 1000 - 100;
              controlTimeShift(2, -0.1);
            }
            break;
          case "m":
            typeAction = "muted";
            changeValue = !playerRef.current.muted;
            setMuted(changeValue);
            break;
          // case "r":
          //   console.log("-------");
          //   break;
        }
        if (typeAction) {
          setShowShortcutsAction({ show: true, typeAction, changeValue });
          setTimeout(() => {
            setShowShortcutsAction({
              show: false,
              typeAction: false,
              changeValue: false,
            });
          }, [1000]);
        }
        // console.log(
        //   `Key: ${event.key} with keycode ${event.keyCode} has been pressed`
        // );
      }
    }
  };

  const mouseWheelAction = (e) => {
    if (
      playerRef.current.mouseOnVideo &&
      !disableShortCut.current &&
      playerRef.current.videoFile &&
      playerRef.current.useShortcuts.on
    ) {
      let newvalue;
      let changeValue;
      if (e.deltaY == "-100") {
        newvalue = playerRef.current.volume + 5;
        if (newvalue < 100) {
          setVolume(newvalue);
          changeValue = newvalue;
        } else {
          setVolume(100);
          changeValue = 100;
        }
        if (playerRef.current.muted) setMuted(false);
      } else if (e.deltaY == "100") {
        newvalue = playerRef.current.volume - 5;
        if (newvalue > 1) {
          setVolume(newvalue);
          changeValue = newvalue;
        } else {
          setVolume(0);
          changeValue = 0;
        }
        if (playerRef.current.muted) setMuted(false);
      }
      e.preventDefault();
      setShowShortcutsAction({
        show: true,
        typeAction: "volume",
        changeValue,
      });
      setTimeout(() => {
        setShowShortcutsAction({
          show: false,
          typeAction: "volume",
          changeValue: false,
        });
      }, [1000]);
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", keydownAction);
  }, []);
  useEffect(() => {
    document.addEventListener("wheel", mouseWheelAction, { passive: false });
  }, []);
  useEffect(() => {
    playerRef.current = {
      ...playerRef.current,
      ...{ volume: volume },
    };
  }, [volume]);
  useEffect(() => {
    playerRef.current = {
      ...playerRef.current,
      ...{ controlHover: controlHover },
    };
  }, [controlHover]);
  useEffect(() => {
    playerRef.current = {
      ...playerRef.current,
      ...{ playbackRate: playbackRate },
    };
  }, [playbackRate]);
  useEffect(() => {
    playerRef.current = {
      ...playerRef.current,
      ...{ activeSubtitleOneId: activeSubtitleOneId },
    };
  }, [activeSubtitleOneId]);
  useEffect(() => {
    playerRef.current = {
      ...playerRef.current,
      ...{ unlimitedRepeat: unlimitedRepeat },
    };
  }, [unlimitedRepeat]);
  useEffect(() => {
    playerRef.current = {
      ...playerRef.current,
      ...{ subtitlesTimeShift: subtitlesTimeShift },
    };
  }, [subtitlesTimeShift]);
  useEffect(() => {
    playerRef.current = {
      ...playerRef.current,
      ...{ useShortcuts: useShortcuts },
    };
  }, [useShortcuts]);
  useEffect(() => {
    playerRef.current = {
      ...playerRef.current,
      ...{ muted: muted },
    };
  }, [muted]);
  useEffect(() => {
    playerRef.current = {
      ...playerRef.current,
      ...{ subtitleSideBar: subtitleSideBar },
    };
  }, [subtitleSideBar]);
  useEffect(() => {
    playerRef.current = {
      ...playerRef.current,
      ...{ mouseOnVideo: mouseOnVideo },
    };
  }, [mouseOnVideo]);

  useEffect(() => {
    disableShortCut.current =
      !useShortcuts.enable ||
      selectVideoBox ||
      mainCompareSubsOpen ||
      signInBox;
  }, [selectVideoBox, mainCompareSubsOpen, signInBox, useShortcuts]);

  const repeatVideo = (time) => {
    videoRef.current.seekTo(time, "seconds");
  };

  const pauseVideo = (time) => {
    if (time > 0) {
      let cp = { ...controlHover };
      if (cp["play"]) {
        cp["play"] = false;
        setControlHover(cp);
        setTimeout(() => {
          cp["play"] = true;
          setControlHover(cp);
        }, time);
      }
    }
  };

  const handlePsVideoPlayer = () => {
    let psResult = psPlayer(
      subtitleOneWords["words"],
      subWordLearningStyles,
      userWordsDifficultyLevel,
      subWordCEFRStyles,
      cferWordsLevel
    );
    if (psResult > 0 && psResult < 10) pauseVideo(psResult * 1000);
  };

  const handleRpVideoPlayer = () => {
    let currentTime = videoRef.current.getCurrentTime();
    if (repeatOn["repeat"] > 0) {
      repeatVideo(repeatOn["repeatTime"]);
      let cp = { ...repeatOn };
      cp["repeat"] = repeatOn["repeat"] - 1;
      setRepeatOn(cp);
    } else if (repeatOn["repeat"] == 0 && repeatOn["state"]) {
      setRepeatOn({ repeatTime: 0, repeat: 0, state: false });
    } else {
      let rpResult = rpPlayer(
        subtitleOneWords["words"],
        subWordLearningStyles,
        userWordsDifficultyLevel,
        subWordCEFRStyles,
        cferWordsLevel
      );
      if (rpResult > 0 && rpResult < 10) {
        setRepeatOn({ repeatTime: currentTime, repeat: rpResult, state: true });
      }
    }
  };

  const checkHiddenSub = (subNumber) => {
    if (semiAutoShadowing["on"]) {
      if (hiddenSub == "show" || hiddenSub == "undercover") {
        return false;
      } else {
        return true;
      }
    } else {
      if (subtitleStylesData[`sub${subNumber}_hidden`]) return true;
      else return false;
    }
  };

  useEffect(() => {
    if (unlimitedRepeat) {
      videoRef.current.seekTo(unlimitedRepeat, "seconds");
    } else {
      handlePsVideoPlayer();
      handleRpVideoPlayer();
    }
  }, [checkRpPsPlayer]);

  useEffect(() => {
    if (controlVideoPlayer["action"] == "changePage") {
      let cp = { ...controlHover };
      if (controlVideoPlayer["value"] == 0) {
        if (oldPlayState["pgnumber"] !== 0 && oldPlayState["play"]) {
          cp["play"] = true;
          setControlHover(cp);
          setOldPlayState({
            pgnumber: controlVideoPlayer["value"],
            play: true,
          });
        }
      } else {
        setOldPlayState({
          pgnumber: controlVideoPlayer["value"],
          play: cp["play"],
        });
        cp["play"] = false;
        setTimeout(() => {
          setControlHover(cp);
        }, 300);
      }
    }
  }, [controlVideoPlayer]);
  return (
    <Box
      ref={ref}
      sx={{
        textAlign: "center",
        width: handleFullScreen.active ? "100%" : "100%",
        height: handleFullScreen.active ? "100vh" : "90vh",
        mt: handleFullScreen.active ? 0 : "10vh",
        ml: handleFullScreen.active ? 0 : 0,
        position: "relative",
      }}
    >
      <BasicSpeedDial
        handleShowSubtitleStyleBox={handleShowSubtitleStyleBox}
        handleFullScreen={handleFullScreen}
        handleOpenSelectSubtitlesBox={handleOpenSelectSubtitlesBox}
        handleOpenSelectVideoBox={handleOpenSelectVideoBox}
        handleSemiAutoShadowing={handleSemiAutoShadowing}
      />
      <Box
        sx={{
          position: "absolute",
          zIndex: "1250",
          width: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        {semiAutoShadowing["shortCut"] && videoInfo.videoFile ? (
          <ShadowingButton
            semiAutoShadowing={semiAutoShadowing}
            handleSemiAutoShadowing={handleSemiAutoShadowing}
            videoRef={videoRef}
            handleFullScreen={handleFullScreen}
            userTypes={userTypes}
            handleShowAllSubtitlesInShadowing={
              handleShowAllSubtitlesInShadowing
            }
          />
        ) : null}
        <SelectMovie
          selectVideoBox={selectVideoBox}
          handleCloseSelectVideoBox={handleCloseSelectVideoBox}
          fullscreenState={fullscreenState}
          handleFullscreenState={handleFullscreenState}
          handleFullScreen={handleFullScreen}
          handleCloseSelectSubtitlesBox={handleCloseSelectSubtitlesBox}
          handleMainCompareSubsOpen={handleMainCompareSubsOpen}
        />
        <CompareSubsPlaying
          videoRef={videoRef}
          handleMainCompareSubsOpen={handleMainCompareSubsOpen}
          mainCompareSubsOpen={mainCompareSubsOpen}
          handleCompareSubtitlesData={handleCompareSubtitlesData}
        />
        {semiAutoShadowing["showSettings"] ? (
          <ShadowingSettings
            semiAutoShadowing={semiAutoShadowing}
            handleSemiAutoShadowing={handleSemiAutoShadowing}
          />
        ) : null}
        {showShortcutsAction.show ? (
          <KeysModal showShortcutsAction={showShortcutsAction} />
        ) : null}
        {videoInfo.videoFile ? (
          <ShortCutEnable
            handleUseShortcuts={handleUseShortcuts}
            useShortcuts={useShortcuts}
            unlimitedRepeat={unlimitedRepeat}
            handleSubtitleSideBar={handleSubtitleSideBar}
            subtitleSideBar={subtitleSideBar}
          />
        ) : null}
        <SelectSubtitles
          handleActiveSubtitleOneId={handleActiveSubtitleOneId}
          handleActiveSubtitleTwoId={handleActiveSubtitleTwoId}
          handleSubtitleTwoDisable={handleSubtitleTwoDisable}
          subtitleTwoDisable={subtitleTwoDisable}
          searchSubtitlesBoxData={searchSubtitlesBoxData}
          handleSearchSubtitlesBoxOpen={handleSearchSubtitlesBoxOpen}
          handleCompareSubtitlesData={handleCompareSubtitlesData}
          compareSubtitlesBoxData={compareSubtitlesBoxData}
          selectSubtitlesBox={selectSubtitlesBox}
          handleCloseSelectSubtitlesBox={handleCloseSelectSubtitlesBox}
          fullscreenState={fullscreenState}
          handleFullscreenState={handleFullscreenState}
          handleFullScreen={handleFullScreen}
          handleMainCompareSubsOpen={handleMainCompareSubsOpen}
        />
        <SubtitileStyles
          handlePlayingStatus={handlePlayingStatus}
          showSubtitleStyleBox={showSubtitleStyleBox}
          handleShowSubtitleStyleBox={handleShowSubtitleStyleBox}
          handleFullScreen={handleFullScreen}
        />
        <SynchronizeSubtitles
          videoRef={videoRef}
          compareSubtitlesBoxData={compareSubtitlesBoxData}
          handlePlaySyncTwoSub={handlePlaySyncTwoSub}
          playSyncTwoSub={playSyncTwoSub}
          subtitlesTimeShift={subtitlesTimeShift}
          handleSubtitlesTimeShift={handleSubtitlesTimeShift}
        />
        {semiAutoShadowing["activeShowSubsContents"] &&
        semiAutoShadowing["on"] ? (
          <Box
            sx={{
              display: "flex",
              width: "100%",
              height: "100vh",
              justifyContent: "center",
              zIndex: "3001",
            }}
          >
            <Paper
              sx={{
                display: "flex",
                width: "90%",
                height: "90vh",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <Button
                variant="contained"
                sx={{ alignSelf: "center", margin: "3px" }}
                onClick={() => {
                  handleSemiAutoShadowing("activeShowSubsContents", false);
                  handlePlayingStatus(true);
                }}
              >
                بستن و پخش فیلم
              </Button>
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  height: "83vh",
                  justifyContent: "space-around",
                }}
              >
                <Box
                  sx={{ width: "48%", border: "2px solid", overflow: "auto" }}
                >
                  <Typography>زیرنویس اول</Typography>
                  <hr />

                  {allSubShadowing["subOne"].map((sub, idx) => (
                    <Typography
                      key={`sub-${idx}`}
                      sx={{ textAlign: "right", borderBottom: "0.2px solid" }}
                    >
                      {sub["text"]}
                    </Typography>
                  ))}
                </Box>
                <Box
                  sx={{ width: "48%", border: "2px solid", overflow: "auto" }}
                >
                  <Typography>زیرنویس دوم</Typography>
                  <hr />
                  {allSubShadowing["subTwo"].map((sub, idx) => (
                    <Typography
                      key={`sub-${idx}`}
                      sx={{ textAlign: "left", borderBottom: "0.2px solid" }}
                    >
                      {sub["text"]}
                    </Typography>
                  ))}
                </Box>
              </Box>
            </Paper>
          </Box>
        ) : null}
      </Box>

      <div
        id="SubtitleContainer"
        style={{
          zIndex: 200,
          position: "absolute",
          bottom: "13%",
          width: "100%",
          display:
            !subtitleTwoDisable &&
            playSyncTwoSub &&
            (!subtitleOneContenet || !subtitleTwoContenet)
              ? "none"
              : "block",
        }}
      >
        <div>
          <DraggableComponent maxWidth={"70%"}>
            <div
              onMouseEnter={() => {
                handlePlayingStatus(false);
                if (semiAutoShadowing["on"]) setHiddenSub("show");
              }}
              onMouseLeave={() => {
                handlePlayingStatus(true);
              }}
              onClick={(event) => {
                handlePlayingStatus(false);
                event.stopPropagation();
              }}
              id="SubtitleOneContent"
              style={{
                filter: hiddenSub == "undercover" ? "blur(8px)" : null,
                touchAction: "none",
                color: subtitleStylesData[`sub1_color`] || "black",
                backgroundColor:
                  subtitleStylesData[`sub1_backGroundColor`] || "",
                fontSize: `${subtitleStylesData[`sub1_fontSize`]}px` || "20px",
                display: checkHiddenSub("1") ? "none" : "inline-flex",
                // maxWidth: "70%",
                direction: "ltr",
                // direction: videoInfo.subtitleOneRtl ? "rtl" : "ltr",
              }}
            >
              <SubtitleOneContentControl
                handleUseShortcuts={handleUseShortcuts}
                handlePlayingStatus={handlePlayingStatus}
                handleFullScreen={handleFullScreen}
                paperComponent={ref.current}
              />
            </div>
          </DraggableComponent>
        </div>
        <div>
          <DraggableComponent>
            <div
              onClick={(event) => {
                event.stopPropagation();
              }}
              onMouseEnter={() => {
                if (semiAutoShadowing["on"]) setHiddenSub("show");
              }}
              id="SubtitleTwoContent"
              style={{
                filter: hiddenSub == "undercover" ? "blur(8px)" : null,
                touchAction: "none",
                color: subtitleStylesData[`sub2_color`] || "black",
                backgroundColor:
                  subtitleStylesData[`sub2_backGroundColor`] || "",
                fontSize: `${subtitleStylesData[`sub2_fontSize`]}px` || "20px",
                display: checkHiddenSub("2") ? "none" : "inline-flex",
                maxWidth: "70%",
                direction: "ltr",
                // direction: videoInfo.subtitleTwoRtl ? "rtl" : "ltr",
              }}
            >
              {userTypes.length > 0 ? (
                <>
                  {subtitleTwoContenet.length > 0 ? (
                    <IconButton
                      onClick={() => {
                        window.open(
                          `https://www.bing.com/translator/?from=${videoInfo["subtitleTwoLanguage"]}&to=${videoInfo["subtitleOneLanguage"]}&text=${subtitleTwoContenet}`,
                          "mozillaWindow",
                          "popup"
                        );
                        handlePlayingStatus(false);
                      }}
                      color="primary"
                    >
                      <GTranslateIcon />
                    </IconButton>
                  ) : null}

                  {subtitleTwoContenet}
                </>
              ) : subtitleTwoContenet ? (
                <AccessDenySubtitleTwo
                  handlePlayingStatus={handlePlayingStatus}
                />
              ) : (
                ""
              )}
            </div>
          </DraggableComponent>
        </div>
      </div>
      <div
        {...getRootProps()}
        style={{ height: videoInfo.videoFile ? "100%" : "50vh", width: "100%" }}
      >
        <input {...getInputProps()} />
        {videoInfo.videoFile ? null : (
          <Box
            sx={{
              width: "90%",
              height: "50vh",
              margin: "auto",
              borderRadius: "20px",
              border: "3px dashed",
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              justifyContent: "center",
              padding: "10px",
            }}
          >
            <Button
              variant="contained"
              component="label"
              color="warning"
              sx={{ ml: 1 }}
              endIcon={<LocalMoviesIcon />}
            >
              <input
                hidden
                id="videoFile"
                name="videoFile"
                type="file"
                onChange={(event) => {
                  handleVideoInfo({
                    videoFile: URL.createObjectURL(event.target.files[0]),
                    fileName: event.target.files[0]["name"],
                    filmName: event.target.files[0]["name"].slice(0, 8),
                  });
                  handleOpenSelectVideoBox();
                }}
              />
              انتخاب فیلم
            </Button>
            <Typography>Drag and drop the movie file</Typography>
            <VideoLibraryIcon fontSize="large" />
          </Box>
        )}
        <Box
          sx={{
            display: videoInfo.videoFile ? "flex" : "none",
            height: "100%",
            width: "100%",
          }}
        >
          <ReactPlayer
            onClick={() => {
              let cp = { ...controlHover };
              cp["play"] = !videoRef.current.player.isPlaying;
              setControlHover(cp);
            }}
            onMouseDown={(e) => {
              if (
                playerRef.current.mouseOnVideo &&
                !disableShortCut.current &&
                playerRef.current.videoFile &&
                playerRef.current.useShortcuts.on &&
                e.button == 1
              ) {
                const getState = videoRef.current.player.isPlaying;
                let changeValue = !moreInfoRef.current.fullScreen;
                moreInfoRef.current.fullScreen
                  ? handleFullScreen.exit()
                  : handleFullScreen.enter();
                setTimeout(() => {
                  let cp = { ...playerRef.controlHover };
                  cp["play"] = getState;
                  setControlHover(cp);
                }, 50);
                setShowShortcutsAction({
                  show: true,
                  typeAction: "fulScreen",
                  changeValue,
                });
                setTimeout(() => {
                  setShowShortcutsAction({
                    show: false,
                    typeAction: "fulScreen",
                    changeValue: false,
                  });
                }, [1000]);
                e.preventDefault();
              }
            }}
            onMouseEnter={() => {
              setMouseOnVideo(true);
            }}
            onMouseLeave={() => {
              setMouseOnVideo(false);
            }}
            ref={videoRef}
            playing={controlHover["play"]}
            playsinline={true}
            onPause={() => {
              handlePlayingStatus(false);
              handleDisableHoverPause(true);
            }}
            onPlay={() => {
              handlePlayingStatus(true);
              handleDisableHoverPause(false);
            }}
            id="MainVideo"
            url={videoInfo.videoFile}
            // اگر یوزر بر روی زمان دیگری از فیلم کلیک کرد سیکل تکرار قطع شود
            onSeek={(time) => {
              if (
                repeatOn["state"] &&
                Math.abs(repeatOn["repeatTime"] - time) > 20
              )
                setRepeatOn({ repeatTime: 0, repeat: 0, state: false });
            }}
            onProgress={(data) => {
              if (semiAutoShadowing["on"]) {
                setActiveShadowing(true);
                if (semiAutoShadowing["currentRepeatIndex"] == 0) {
                  handleSemiAutoShadowing("on", false);
                  setplaybackRate(1);
                  setVolume(semiAutoShadowing[`defaultVolume`]);
                  setHiddenSub("show");
                } else {
                  if (
                    data["playedSeconds"] > semiAutoShadowing["endTime"] ||
                    data["playedSeconds"] < semiAutoShadowing["startTime"] - 2
                  ) {
                    let repeatNumber =
                      semiAutoShadowing["repeat"] -
                      semiAutoShadowing["currentRepeatIndex"] +
                      1;
                    handleSemiAutoShadowing(
                      "currentRepeatIndex",
                      semiAutoShadowing["currentRepeatIndex"] - 1
                    );
                    repeatVideo(semiAutoShadowing["startTime"]);
                    setplaybackRate(
                      semiAutoShadowing[`repeatNumber${repeatNumber}`]["rate"]
                    );
                    setVolume(
                      semiAutoShadowing[`repeatNumber${repeatNumber}`]["volume"]
                    );
                    setHiddenSub(
                      semiAutoShadowing[`repeatNumber${repeatNumber}`]["hidden"]
                    );
                  }
                }
              } else {
                if (activeShadowing) {
                  setActiveShadowing(false);
                  setplaybackRate(1);
                  setVolume(semiAutoShadowing[`defaultVolume`]);
                  setHiddenSub("show");
                }
              }
            }}
            playbackRate={playbackRate}
            volume={volume / 100}
            muted={muted}
            controls
            width="100%"
            height="100%"
            config={{
              file: {
                attributes: {
                  controlsList: "nofullscreen",
                },
              },
            }}
            // config={videoInfo.config}
          ></ReactPlayer>
          {subtitleSideBar.active ? (
            <Paper
              sx={{
                width: `${subtitleSideBar.size}%`,
                height: "100%",
                overflow: "auto",
              }}
            >
              <SubtitleSidebar
                activeSubtitleOneId={activeSubtitleOneId}
                activeSubtitleTwoId={activeSubtitleTwoId}
                seekToVideo={seekToVideo}
                handleSubtitleSideBar={handleSubtitleSideBar}
              />
            </Paper>
          ) : null}
        </Box>
      </div>
      <Box sx={{ pl: "10px", pr: "10px", height: "100%", marginTop: "20px" }}>
        <StartBox
          handleFullScreen={handleFullScreen}
          handlePlayingStatus={handlePlayingStatus}
        />
        <AccordianContents
          handleOpenSelectVideoBox={handleOpenSelectVideoBox}
          handleFullScreen={handleFullScreen}
          handlePlayingStatus={handlePlayingStatus}
        />
        {/* <Tutorialumlang /> */}
      </Box>

      <SubtitleOneTranslations loadingSub={false} />

      {handleFullScreen.active ? (
        <ToastContainer
          position="top-center"
          autoClose={1300}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={true}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      ) : (
        <></>
      )}
    </Box>
  );
}

export default VideoPlayer;
